var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.id === 'columns')?_c('column-config'):_vm._e(),(_vm.id === 'data-config')?_c('data-config'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }